import { memo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { useIntl } from 'react-intl'

import BodyText from 'LuxKit/Typography/BodyText'
import Pane from 'components/Common/Pane/Pane'
import Group from 'components/utils/Group'
import NumberRating from 'components/Common/NumberRating/NumberRating'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

const Container = styled(Pane)`
  padding: ${rem(16)} ${rem(20)};
`

const RatingWrapper = styled.div`
  flex-shrink: 0;
  white-space: nowrap;
`

interface Props {
  content: string
  score: number
  reviewsTotal: number
}

function OfferPageReviewAiSummary({
  content,
  score,
  reviewsTotal,
}: Props) {
  const intl = useIntl()

  return (
    <Container background="neutral-seven">
      <Group direction="vertical" gap={12}>
        <Group direction="horizontal" gap={20} verticalAlign="start">
          <RatingWrapper>
            <NumberRating
              link
              rating={score}
              total={reviewsTotal}
              variant="xl"
              hideLabel
              layout="vertical"
            />
          </RatingWrapper>
          <Group direction="vertical" gap={8}>
            <Group direction="vertical" tabletDirection="horizontal" gap={4} tabletGap={8} verticalAlign="center" tabletHorizontalAlign="space-between">
              <BodyText variant="large" weight="bold">
                {intl.formatMessage({
                  id: 'uUdB4FuUUHKUZ8vXWn2C',
                  defaultMessage: 'What guests say',
                  description: 'Heading title for the AI-generated guest review summary section on the offer page',
                })}
              </BodyText>
              <BodyText variant="small" colour="neutral-three">
                {intl.formatMessage({
                  id: 'IZ2kMn_kaYATWxfAbhHu',
                  defaultMessage: 'AI-generated based on customer reviews',
                  description: 'Badge label indicating the review summary content is AI-generated on the offer page',
                })}
              </BodyText>
            </Group>
            <CSSBreakpoint min="tablet">
              <BodyText variant="medium" colour="neutral-two">{content}</BodyText>
            </CSSBreakpoint>
          </Group>
        </Group>
        <CSSBreakpoint max="mobile">
          <BodyText variant="medium" colour="neutral-two">{content}</BodyText>
        </CSSBreakpoint>
      </Group>
    </Container>
  )
}

export default memo(OfferPageReviewAiSummary)
